import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TaskAssignee, TaskLabel } from '../../taskbook.types';
import { TaskAssigneeAndLabelPopoverComponent } from '../../task-assignee-and-label-popover/task-assignee-and-label-popover.component';

@Component({
    selector: 'keep-triage-action',
    templateUrl: './keep-triage-action.component.html',
    styleUrls: ['./keep-triage-action.component.scss', './../../taskbook-triage-actions/taskbook-triage-actions.component.scss', './../../task/task.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule,
      TaskAssigneeAndLabelPopoverComponent
    ]
})
export class KeepTriageActionComponent {
   
    protected context: string = 'triage';
    protected isPopoverOpen = false;

    @Input() managers: TaskAssignee[];
    @Input() selectedAssignees: TaskAssignee[];
    @Input() selectedLabels: TaskLabel[];
    @Output() keep = new EventEmitter<{ labels: TaskLabel[], assignees: TaskAssignee[]}>();


    constructor() {}

    togglePopover(): void {
        this.isPopoverOpen = !this.isPopoverOpen;
    }

    onApply(selection: { labels: TaskLabel[], assignees: TaskAssignee[]}) {
        this.keep.emit(selection);
        this.isPopoverOpen = false;
        this.selectedLabels = [];
    }

}    